import { getAPIURL } from 'constants/environment'
import routes from './routes'

export const generateOauthAuthorizeUrl = (queryParams: URLSearchParams) =>
  `${getAPIURL()}/oauth2/authorize?${queryParams.toString()}`

export const generateRedirectUrl = (queryParams: URLSearchParams) => `${routes.cmsRedirect}?${queryParams.toString()}`

export const isCmsRedirect = (queryParams: URLSearchParams) => queryParams.get('callback_action') === 'oauth2'
